// React and hooks
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';

import { useTranslation } from 'react-i18next';

// Material UI components
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Autocomplete, Checkbox } from '@mui/material';

// Material UI icons
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import UploadIcon from '@mui/icons-material/Upload';
import ClearIcon from '@mui/icons-material/Clear';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

// Date picker
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// Third-party libraries
import dayjs from 'dayjs';
import { usePostSaveLogWhtMutation } from '../../services/saveLogWht';

// Custom components and services
import TableInvoice from '../../components/TableInvoice/TableInvoice';
import PaymentInvDialog from '../../components/Dialog/PaymentInvDialog';
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import NotiAlertComfirm from '../../components/NotiAlert/NotiAlertComfirm';
import UploadSlip from '../../components/Dialog/UploadSlip';
import DocumentsDownload from '../../components/DocumentDownload/eDocumentsDownload';
import Loading from '../../components/Loading';
// API services
import {
  useGetInvoiceListQuery,
  useGetQuotationNOQuery,
} from '../../services/invoiceList';
import {
  useToPayCreateMutation,
  usePayCreateMutation,
} from '../../services/paymentTransaction';

import CsatDialog from '../../components/Dialog/CsatDialog';
import { data } from 'autoprefixer';
import BaseButton from '../../components/Button/BaseButton';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useCheckPeriodMutation } from '../../services/invoiceList';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

function InvoiceMain() {
  const { t } = useTranslation();

  const [sortOrder, setSortOrder] = useState(''); 
  console.log("🚀 ~ InvoiceMain ~ sortOrder:", sortOrder)
  const [customerName, SetCustomerName] = useState('');
  const [total, setTotal] = useState(10);
  const [selectedRows, setSelectedRows] = useState([]);
  const [invoiceItems, setinvoiceItems] = useState([]);
  const [invoiceNOItems, setInvoiceNOItems] = useState([]);
  const [selectWHT, setSelectWHT] = useState([]);
  const [payTypeValue, setPayTypeValue] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [quotationNo, setQuotationNo] = useState('');
  const [soPaymentStatus, setSoPaymentStatus] = useState('');
  const [paystatusValue, setPaystatusValue] = useState([]);
  const [openDialogSlip, setOpenDialogSlip] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState('');
  const [openPay, setOpenPay] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openAlertComfirm, setOpenAlertComfirm] = useState(false);
  const [selectWHTRate, setSelectWHTRate] = useState(null);
  const [calTotal, setCalTotal] = useState(null);
  const [selectedWht, setSelectedWht] = useState(false);
  const [checkOverdue, setCheckOverdue] = useState(false);
  const [postSaveLogWht] = usePostSaveLogWhtMutation();
  const [checkPeriod] = useCheckPeriodMutation();

  const paymentType = [
    { label: t('app.all'), value: 'All' },
    { label: t('app.postPaid'), value: 'Post-Paid' },
    { label: t('app.prePaid'), value: 'Pre-Paid' },
  ];

  const paymentTypeMap = paymentType.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});

  const paymentStatus = [
    { label: t('app.unpaid'), value: 'Unpaid', color: '#ff1744' },
    { label: t('app.paid'), value: 'Paid', color: '#2e7d32' },
    { label: t('app.pending'), value: 'Pending', color: '#f57f17' },
    { label: t('app.overdue'), value: 'Overdue', color: '#ff1744' },
    { label: 'Credit Note', value: 'Credit Note', color: '#616161' },
    { label: 'Partial', value: 'Partial', color: '#e0b800' },
  ];

  const getStatusOption = (value) =>
    paymentStatus.find((status) => status.value === value);

  const isWhtBlockedRow = (row = {}) => {
    const soNumber = String(row?.so_number || '').trim();
    const invoiceNo = String(row?.invoice_no || '').trim();
    const blockedSoPrefixes = ['SO02', 'SO12', 'SO13', 'SO09', 'SO07', 'SO05'];

    return (
      !soNumber ||
      blockedSoPrefixes.some((prefix) => soNumber.startsWith(prefix)) ||
      invoiceNo.startsWith('BOI')
    );
  };

  const [isAvailable, setIsAvailable] = useState(false);

  const handlePaymentTypeChange = (event) => {
    const selectedValues = event.target.value;
    const allPaymentTypeValues = paymentType.map(({ value }) => value);
    const individualPaymentTypeValues = allPaymentTypeValues.filter(
      (value) => value !== 'All',
    );
    const wasAllSelected = payTypeValue.includes('All');
    const isAllSelected = selectedValues.includes('All');

    if (isAllSelected && !wasAllSelected) {
      setPayTypeValue(allPaymentTypeValues);
      return;
    }

    if (!isAllSelected && wasAllSelected) {
      setPayTypeValue([]);
      return;
    }

    const selectedIndividuals = selectedValues.filter(
      (value) => value !== 'All',
    );

    if (selectedIndividuals.length === individualPaymentTypeValues.length) {
      setPayTypeValue(allPaymentTypeValues);
      return;
    }

    setPayTypeValue(selectedIndividuals);
  };

  const [textPay, setTextPay] = useState({
    title: '',
    textButton: '',
  });
  const [notiItem, setNotiItem] = useState({
    title: '',
    value: '',
    text: '',
  });

  const [annotation, setAnnotation] = useState({
    topayNote: '',
    paymentNote: '',
  });
  const {
    value: custNO,
    federalTaxId,
    federal_hash_tax_id,
  } = useSelector((state) => state.custNO);

  const merchant = useSelector((state) => state.merchant.value);

  const navigate = useNavigate();

  // ✅ การจัดการสิทธิ์ (Role Management)
  const token = localStorage.getItem('token');
  const decodedToken = token ? jwtDecode(token) : null;
  const userRole = decodedToken?.ROLE || ''; 

  // ✅ สร้างตัวแปรเช็คว่าเป็น SALE หรือไม่
  const isSaleRole = userRole === 'SALE' || userRole === 'SALES'; 

  const isAdmin = token
    ? userRole !== 'USER' && userRole !== 'SALE' && 
      (textPay ? true : textPay.title === 'Payment / ชำระเงิน')
    : false;

  const isUserInterface = userRole === 'USER' || userRole === 'SALE';

  const {
    data: invList,
    isLoading,
    isFetching,
    refetch,
  } = useGetInvoiceListQuery(
    {
      customerCode: merchant ? custNO : '',
      sorgcode: merchant || '',
      paymentStatus: paystatusValue,
      soPaymentStatus,
      paymentType:
        payTypeValue.length === 2 || payTypeValue.includes('All')
          ? 'All'
          : payTypeValue,
      startDate: startDate ? dayjs(startDate).format('YYYYMMDD') : '',
      endDate: endDate ? dayjs(endDate).format('YYYYMMDD') : '',
      search,
      sort: sortOrder ? `${sortOrder.field}:${sortOrder.direction}` : '',
      federalTaxId: federalTaxId || '',
      quotation: quotationNo,
      page: page + 1,
      size: rowsPerPage,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !custNO && (userRole === 'SUPER ADMIN' || userRole === 'SALE'), 
    }
  );

  const { data: qtList } = useGetQuotationNOQuery({
    customerCode: merchant ? custNO : '',
    sorgcode: merchant || '',
    federalTaxId: federalTaxId || '',
  });

  const [toPayCreate] = useToPayCreateMutation();
  const [payCreate] = usePayCreateMutation();
  const [customerEmail, setCustomerEmail] = useState('');

  useEffect(() => {
    if (invList?.total) {
      setTotal(invList?.total);
    }
  }, [invList]);

  useEffect(() => {
    // ✅ ป้องกัน Error .map ด้วยการเช็คค่าว่าง
    if (invList?.message === 'OK') {
      const items = invList?.data || [];
      setinvoiceItems(items);
    } else {
      setinvoiceItems([]);
    }
  }, [invList]);

  const [isFirstRender, setIsFirstRender] = useState(true);
  const checkInv = async (item) => {
    const dataNoInet = item.filter((i) => !isWhtBlockedRow(i));
    const setData = dataNoInet.map((i) => ({
      invoice_no: i.invoice_no,
      period: i.period,
      so_number: i.so_number,
    }));
    setSelectWHT(setData);
  };

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    } else {
      checkInv(selectedRows);
    }
  }, [selectedRows]);
  
  useEffect(() => {
    SetCustomerName(selectedRows[0]?.customer?.customer_name || '');
  }, [selectedRows]);

  const checkStatus = selectedRows.some((e) => e.payment_status === 'Paid');
  const result = !checkStatus;

  const payload = selectedRows.map((row) => ({
    period: row.period,
    so_number: row.so_number,
    customer_code: row.customer_code,
    sorgcode: row.sorgcode,
  }));

  const handleOnClickPayment = async () => {
    const res = await checkPeriod(payload);
    if (res?.data?.message === 'OK') {
      if (selectedRows.length > 0) {
        setTextPay({
          ...textPay,
           title: t('app.payment'),
        paymentType: 'Payment', 
        textButton: t('app.pay'),
        });
        checkInv(selectedRows);
        setOpenPay(true);
      } else {
        setNotiItem({
           title: t('app.pleaseSelectInvoice'),
          value: 'error',
        });
        setOpenAlert(true);
      }
    } else if (
      res.error?.data?.error?.message === 'Previous installment unpaid.'
    ) {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'รายการนี้ไม่สามารถชำระเงินได้ ต้องชำระเงิน ตาม Period ก่อนหน้า',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else if (res.error?.data?.error?.message === 'Some period already paid') {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการที่ชำระเงินแล้ว',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการมีข้อผิดพลาด',
        value: 'cancel',
      });
      setOpenAlert(true);
    }
  };

  const handleOnClickToPayment = async () => {
    const res = await checkPeriod(payload);
    if (res?.data?.message === 'OK') {
      if (selectedRows.length > 0) {
        setTextPay({
          ...textPay,
   title: t('app.toPay'),
        paymentType: 'TOPAY', 
        textButton: t('app.submit'),
        });
        checkInv(selectedRows);
        setOpenPay(true);
      } else {
        setNotiItem({
           title: t('app.pleaseSelectInvoice'),
          value: 'error',
        });
        setOpenAlert(true);
      }
    } else if (
      res.error?.data?.error?.message === 'Previous installment unpaid.'
    ) {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'รายการนี้ไม่สามารถชำระเงินได้ ต้องชำระเงิน ตาม Period ก่อนหน้า',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else if (res.error?.data?.error?.message === 'Some period already paid') {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการที่ชำระเงินแล้ว',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการมีข้อผิดพลาด',
        value: 'cancel',
      });
      setOpenAlert(true);
    }
  };

  const handleOpenDialogUploadSlip = async () => {
    const res = await checkPeriod(payload);
    if (res?.data?.message === 'OK') {
      if (selectedRows.length > 0) {
        checkInv(selectedRows);
        setOpenDialogSlip(true);
      } else {
        setNotiItem({
          title: t('app.pleaseSelectInvoice'),
          value: 'error',
        });
        setOpenAlert(true);
      }
    } else if (
      res.error?.data?.error?.message === 'Previous installment unpaid.'
    ) {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'รายการนี้ไม่สามารถชำระเงินได้ ต้องชำระเงิน ตาม Period ก่อนหน้า',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else if (res.error?.data?.error?.message === 'Some period already paid') {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการที่ชำระเงินแล้ว',
        value: 'cancel',
      });
      setOpenAlert(true);
    } else {
      setNotiItem({
        title: 'กรุณาเลือกรายการใหม่',
        text: 'เนื่องจากมีรายการมีข้อผิดพลาด',
        value: 'cancel',
      });
      setOpenAlert(true);
    }
  };

  const handleOnClose = () => {
    setOpenAlert(false);
  };

  useEffect(() => {
    const newValueList = invList?.data;

    const overdueItemsselect = selectedRows?.filter(
      (item) => item.payment_status === 'Overdue',
    );
    const overdueItems = newValueList?.filter(
      (item) => item.payment_status === 'Overdue',
    );
    setCheckOverdue(
      selectedRows.length > 0
        ? overdueItemsselect?.length === overdueItems?.length
        : false,
    );
  }, [selectedRows, checkOverdue]);

  const uniqueInvs = () => {
    const periodsInRow2 = selectWHT.map((item) => item.invoice_no);

    return [
      ...new Set(
        selectedRows
          .filter(
            (item) =>
              !periodsInRow2.includes(item.invoice_no) &&
              !isWhtBlockedRow(item),
          )
          .map((item) => item.invoice_no),
      ),
    ];
  };

  useEffect(() => {
    setInvoiceNOItems(uniqueInvs);
  }, [selectedRows, selectWHT]);

  const onClickTopay = async () => {
    try {
      const periodList = selectedRows.map((row) => {
        const isWhtBlocked = isWhtBlockedRow(row);

        const selectedWhtRow = Array.isArray(selectedWht)
          ? selectedWht.find((r) => r.invoice_no === row.invoice_no)
          : null;

        const isTicked =
          Array.isArray(selectWHT) &&
          selectWHT.some((r) => r.invoice_no === row.invoice_no);

        return {
          ...row,
          wht_selected: isWhtBlocked
            ? false
            : selectedWhtRow
            ? selectedWhtRow.wht_selected
            : isTicked
            ? true
            : false,
        };
      });

      const payload = {
        body: {
          customerCode: custNO,
          sorgcode: merchant,
          totalAmount: calTotal?.total_amount,
          totalVat: calTotal?.total_vat,
          whtRate: selectWHTRate,
          totalWht: calTotal?.whtAmount || '0',
          totalFines: 0,
          totalFee: 20,
          totalDiscount: calTotal?.discount,
          grandTotal: calTotal?.grandTotal,
          periodList,
          remark: annotation.paymentNote,
        },
      };

      const logPayload = {
        sorgcode: merchant,
        invoiceNo: selectedRows.map((row) => row.invoice_no),
        type: textPay.paymentType === 'Payment' ? 'PAYMENT' : 'TOPAY',
        whtInvoiceNo: selectWHT
          .filter((row) => !isWhtBlockedRow(row))
          .map((row) => row.invoice_no),
      };

      const [res1, res2] = await Promise.all([
        textPay.paymentType === 'Payment'
          ? payCreate(payload)
          : toPayCreate(payload),
        postSaveLogWht(logPayload).unwrap(),
      ]);

      if (res1.data.message === 'OK' && res2.message === 'OK') {
        if (textPay.paymentType === 'Payment') {
          window.location = res1.data.data.url;
        } else {
          setOpenPay(false);
          navigate('/waiting-for-payment', {
            state: { OrderValue: res1.data },
          });
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const onClickAlert = () => {
    const itemsBOI = selectedRows.filter((i) => isWhtBlockedRow(i));

    const checkwhtBOI =
      selectedRows.length > 0
        ? itemsBOI?.length === selectedRows?.length
        : false;
    if (invoiceNOItems.length > 0 && checkwhtBOI === false) {
      setOpenAlertComfirm(true);
    } else {
      onClickTopay();
    }
  };

  useEffect(() => {
    setSelectedRows([]);
    setPage(0);
  }, [merchant, custNO]);
  useEffect(() => {
    setPage(0);
  }, [
    quotationNo,
    soPaymentStatus,
    payTypeValue,
    paystatusValue,
    startDate,
    endDate,
    search,
    sortOrder,
  ]);

  return (
    <>
      <CsatDialog />

      <div className="font-bold text-lg">{t('app.service')}</div>

      <div className="flex flex-col lg:flex-row gap-4">
        <Autocomplete
          freeSolo
          size="small"
          fullWidth
          options={qtList?.data[0]?.quotation || []}
          value={quotationNo || ''}
          onChange={(event, newValue) => setQuotationNo(newValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('app.quotationNo')}
              InputProps={{
                ...params.InputProps,
                endAdornment: <>{params.InputProps.endAdornment}</>,
              }}
            />
          )}
        />

        <FormControl fullWidth size="small">
          <InputLabel id="demo-multiple-select-label">
            {t('app.paymentType')}
          </InputLabel>
          <Select
            labelId="demo-multiple-select-label"
            id="demo-multiple-select"
            multiple
            value={payTypeValue || []}
            onChange={handlePaymentTypeChange}
            renderValue={(selected) =>
              selected.includes('All')
                ? paymentTypeMap.All
                : selected.map((value) => paymentTypeMap[value]).join(', ')
            }
            label="Payment Type"
            endAdornment={
              payTypeValue.length > 0 && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setPayTypeValue([])}
                    edge="end"
                    size="small"
                    sx={{ marginRight: '8px' }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )
            }
          >
            {paymentType.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                <Checkbox checked={payTypeValue.includes(option.value)} />
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <InputLabel id="demo-multiple-select-label">
            {t('app.statusPayment')}
          </InputLabel>
          <Select
            labelId="demo-multiple-select-label"
            id="demo-multiple-select"
            multiple
            value={paystatusValue}
            onChange={(event) => setPaystatusValue(event.target.value)}
            renderValue={(selected) => {
              const statusElements = selected.map((value, index) => {
                const option = getStatusOption(value);
                const label = option ? option.label : value;
                const colorName = option ? option.color : 'default';

                return (
                  <Box
                    key={value}
                    component="span"
                    sx={{
                      whiteSpace: 'pre',
                      color: colorName,
                      paddingRight: index < selected.length - 1 ? '4px' : '0',
                    }}
                  >
                    {label}
                    {index < selected.length - 1 ? ', ' : ''}
                  </Box>
                );
              });

              return (
                <Box
                  sx={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap', 
                    textOverflow: 'ellipsis', 
                    display: 'block',
                    width: 'calc(100% - 30px)', 
                  }}
                >
                  {statusElements}
                </Box>
              );
            }}
            label="Status Payment"
            endAdornment={
              paystatusValue.length > 0 && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setPaystatusValue([])}
                    edge="end"
                    size="small"
                    sx={{ marginRight: '8px' }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )
            }
          >
            {paymentStatus.map((option, index) => (
              <MenuItem
                key={index}
                value={option.value}
                sx={{ color: option.color }}
              >
                <Checkbox checked={paystatusValue.includes(option.value)} />
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={t('app.startDate')}
            sx={{ width: '100%', backgroundColor: '#fff' }}
            slotProps={{ textField: { size: 'small' } }}
            value={startDate}
            views={['year', 'month', 'day']}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={t('app.endDate')}
            sx={{ width: '100%', backgroundColor: '#fff' }}
            slotProps={{ textField: { size: 'small' } }}
            value={endDate}
            views={['year', 'month', 'day']}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>

        <TextField
          id="outlined-basic"
          label={t('app.search')}
          variant="outlined"
          placeholder="Invoice No./Sale Order/Service Name"
          fullWidth
          size="small"
          value={search}
          type="text"
          onChange={(event) => {
            setSearch(event.target.value);
          }}
          inputProps={{
            className: 'placeholder:text-xs placeholder:text-gray-400',
          }}
          InputProps={{
            endAdornment: search && (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setSearch('')}
                  edge="end"
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div className="flex flex-col md:flex-row md:justify-between mt-5 gap-4">
        <div className="text-lg">
          <div className="grid justify-center">
            {t('app.eDocuments')}
            <DocumentsDownload
              customerName={customerName}
              merchant={merchant}
              setCustomerEmail={setCustomerEmail}
              customerEmail={customerEmail}
              openAlert={openAlert}
              setOpenAlert={setOpenAlert}
              selectedRows={selectedRows}
              selectWHT={selectWHT}
              setSelectWHT={setSelectWHT}
              isAdmin={isAdmin} // ✅ ส่ง isAdmin ไป ซึ่ง SALE จะมีค่าเป็น false
              handleOpenDialogUploadSlip={handleOpenDialogUploadSlip}
              handleOnClickToPayment={handleOnClickToPayment}
              roleAcc={userRole}
            />
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row md:items-end gap-4">
          <div className="grid justify-center">
            <div className="text-lg text-gray-800">SO Status</div>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <Select
                id="so-payment-status"
                value={soPaymentStatus}
                onChange={(event) => setSoPaymentStatus(event.target.value)}
                displayEmpty
                sx={{
                  height: 36,
                  color: '#fff',
                  fontWeight: 600,
                  backgroundColor: '#4caf50',
                  borderRadius: '999px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.22)',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover': {
                    backgroundColor: '#43a047',
                  },
                  '&.Mui-focused': {
                    backgroundColor: '#43a047',
                  },
                  '& .MuiSelect-icon': {
                    color: '#fff',
                  },
                }}
                renderValue={(value) => {
                  if (!value) return 'All';
                  if (value === 'Payment Due') return 'ที่ต้องชำระ';
                  return 'ชำระครบแล้ว';
                }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Payment Due">ที่ต้องชำระ</MenuItem>
                <MenuItem value="Fully Paid">ชำระครบแล้ว</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* ✅ ถ้าเป็น User หรือ Sale จะเห็นปุ่ม Manage Payments */}
          {isUserInterface && (
            <div className="grid justify-center">
            <div className="text-lg text-gray-800">
              {t('app.managePayments')}
            </div>

            <div className="flex flex-col gap-4 md:flex-row md:flex-wrap ">
              <BaseButton
                text={t('app.toPay')}
                tooltip="รายการรอจ่าย"
                icon={<HourglassEmptyIcon />}
                onClick={handleOnClickToPayment}
                sorgcode={merchant}
                codition="JV"
                variant="contained"
                disabled={isSaleRole} // ✅ เพิ่มตรงนี้
              />

              <BaseButton
                text={t('app.uploadSlip')}
                tooltip="อัพโหลดหลักฐานการทำจ่าย"
                icon={<UploadIcon />}
                onClick={handleOpenDialogUploadSlip}
                sorgcode={merchant}
                codition="JV"
                variant="contained"
                disabled={isSaleRole} // ✅ เพิ่มตรงนี้
              />

              <BaseButton
                text={t('app.payment')}
                tooltip="ชำระเงิน"
                icon={<ShoppingCartOutlinedIcon />}
                onClick={handleOnClickPayment}
                sorgcode={merchant}
                codition="JV"
                variant="contained"
                disabled={isSaleRole} // ✅ เพิ่มตรงนี้
              />
            </div>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center my-2 text-sm font-semibold">
        <span>
          {t('app.selected')} {selectedRows.length} {t('app.items')}
          <IconButton
            aria-label="clear-selection"
            color="error"
            size="small"
            onClick={() => setSelectedRows([])}
            disabled={selectedRows.length === 0}
          >
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </span>
      </div>

      <TableInvoice
        customerName={customerName}
        custNO={custNO}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        isFetching={isFetching}
        total={total}
        invoiceItems={invoiceItems}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        merchant={merchant}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        isLoading={isLoading}
      />

      <PaymentInvDialog
        openPay={openPay}
        setOpenPay={setOpenPay}
        selectedRows={selectedRows}
        textPay={textPay}
        selectWHT={selectWHT}
        setSelectWHT={setSelectWHT}
        selectWHTRate={selectWHTRate}
        setSelectWHTRate={setSelectWHTRate}
        calTotal={calTotal}
        setCalTotal={setCalTotal}
        handleOnClick={onClickAlert}
        setAnnotation={setAnnotation}
        annotation={annotation}
        isAdmin={isAdmin}
        setSelectedWht={setSelectedWht}
        selectedWht={selectedWht}
      />
      
      <NotiAlert
        open={openAlert}
        setOpen={setOpenAlert}
        title={notiItem.title} 
        value={notiItem.value}
        onButtonClick={handleOnClose}
        errorValue={notiItem.text}
      />
      <NotiAlertComfirm
        open={openAlertComfirm}
        setOpen={setOpenAlertComfirm}
        invoiceNOItems={invoiceNOItems}
        onButtonClick={onClickTopay}
      />
      <UploadSlip
      
        refetchInvList={refetch}
        customerName={customerName}
        openDialogSlip={openDialogSlip}
        setOpenDialogSlip={setOpenDialogSlip}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        merchant={merchant}
        custNO={custNO}
        selectWHT={selectWHT}
        setSelectWHT={setSelectWHT}
        setInvoiceNOItems={setInvoiceNOItems}
        invoiceNOItems={invoiceNOItems}
        federal_hash_tax_id={federal_hash_tax_id}
        federalTaxId={federalTaxId}
      />
    </>
  );
}

export default InvoiceMain;
